import React from 'react';
import { Input, InputGroup, InputGroupText } from 'reactstrap';
import { mergeClassNames } from '../../../../shared/utility';

export function ZipcodeInput({
    elementConfig,
    analyticsClassName,
    warningAnalyticsClassName,
    value,
    sharedLabelAttr,
    onChange,
    isInvalid,
    isValid,
    isWarning,
    inlineIcon,
    required,
}) {
    const warningActive = isWarning;
    const warningInputClass = warningActive
        ? mergeClassNames('border-warning', 'is-warning', 'focus-ring', warningAnalyticsClassName)
        : '';
    const warningInputStyle = warningActive
        ? {
              '--bs-focus-ring-color': 'rgba(var(--bs-warning-rgb), .25)',
              '--bs-form-control-focus-border-color': 'var(--bs-warning)',
          }
        : undefined;
    const mergedClassName = mergeClassNames(elementConfig?.className, warningInputClass);
    const mergedStyle = elementConfig?.style ? { ...elementConfig.style, ...warningInputStyle } : warningInputStyle;

    let validationStateClass = '';
    if (warningActive) {
        validationStateClass = 'is-warning';
    } else if (isInvalid) {
        validationStateClass = 'is-invalid';
    } else if (isValid) {
        validationStateClass = 'is-valid';
    }

    const coreInput = (
        <Input
            {...elementConfig}
            invalid={isInvalid}
            className={mergeClassNames(mergedClassName, analyticsClassName)}
            style={mergedStyle}
            value={value}
            {...sharedLabelAttr}
            onChange={onChange}
            valid={isValid}
            required={required}
            aria-required={required}
        />
    );

    if (inlineIcon) {
        return (
            <InputGroup>
                <InputGroupText className={validationStateClass}>
                    {inlineIcon && React.createElement(inlineIcon, { size: 20 })}
                </InputGroupText>
                {coreInput}
            </InputGroup>
        );
    }

    return coreInput;
}
